import { URL } from '../../../config'
import { postRequest } from '../../../utils/functions/httpRequest'

export default function (prefix, suffix, firstName, lastName,dob, email,appId,applicationroleId,ssoUserId, token) 
{
  const accessRequestURL =  `${URL.user}/accessrequest` 
  const accessRequest =
  {
    Role:applicationroleId,
    Prefix: prefix,
    Suffix: suffix,
    FirstName: firstName,
    LastName: lastName,
    Email: email,
    DOB: dob,
    SSOUserId: ssoUserId
  }
  return postRequest(accessRequestURL,accessRequest,token)
}



// WEBPACK FOOTER //
// ./src/containers/userregistration/api/requestAccess.js